<template>
  <div class="commissionDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.salesManagement.title5 }}</div>

      <van-field
        v-model="content.OrderNumber"
        :label="$t.salesManagement.erNumber"
        readonly
      />

      <van-field v-model="content.UserName" :label="$t.salesManagement.sales" readonly />

      <van-field
        v-model="content.CreateTime"
        :label="$t.salesManagement.entrustDay"
        readonly
      />

      <div class="title">{{ $t.salesManagement.title6 }}</div>

      <van-field
        v-model="content.Shipper.CompanyName"
        :label="$t.salesManagement.shipper"
        readonly
        v-if="content.Shipper"
      />

      <van-field
        v-model="content.Consignee.CompanyName"
        :label="$t.salesManagement.consignee"
        readonly
        v-if="content.Consignee"
      />

      <van-field
        v-model="content.Notify.CompanyName"
        :label="$t.salesManagement.notify"
        readonly
        v-if="content.Notify"
      />

      <van-field
        :value="content.DeliveryCountryName + ',' + content.DeliveryCityName"
        :label="$t.salesManagement.deliveryPort"
        readonly
        v-if="content.DeliveryCountryName"
      />

      <van-field
        :value="content.DestinationCountryName + ',' + content.DestinationCityName"
        :label="$t.salesManagement.destinationPort"
        readonly
        v-if="content.DestinationCountryName"
      />

      <van-field
        v-model="content.TCName"
        :label="$t.salesManagement.tradeTerms"
        readonly
      />

      <van-field
        v-model="content.FPName"
        :label="$t.salesManagement.paymentTerms"
        readonly
      />

      <div class="title">{{ $t.salesManagement.title2 }}</div>

      <van-field
        v-model="content.GoodsName"
        :label="$t.salesManagement.goodsName"
        readonly
      />

      <van-field v-model="packing" :label="$t.salesManagement.pNumber" readonly />

      <van-field v-model="volume" :label="$t.salesManagement.volume" readonly />

      <van-field v-model="weight" :label="$t.salesManagement.weight" readonly />

      <div class="commissionDetail-checkbox">
        <div class="checkbox-label">{{ $t.salesManagement.goodsData }}</div>
        <van-checkbox-group v-model="shippmentData" direction="horizontal" disabled>
          <van-checkbox :name="1">{{ $t.salesManagement.brand }}</van-checkbox>
          <van-checkbox :name="2">{{ $t.salesManagement.liquid }}</van-checkbox>
          <van-checkbox :name="3">{{ $t.salesManagement.powder }}</van-checkbox>
          <van-checkbox :name="4">{{ $t.salesManagement.magnetic }}</van-checkbox>
          <van-checkbox :name="5">{{ $t.salesManagement.export1 }}</van-checkbox>
          <van-checkbox :name="6">{{ $t.salesManagement.export2 }}</van-checkbox>
          <van-checkbox :name="7">{{ $t.salesManagement.export3 }}</van-checkbox>
        </van-checkbox-group>
      </div>

      <van-field
        v-model="content.TakeDeliveryAddress"
        :label="$t.salesManagement.tdService"
        type="textarea"
        readonly
      />
    </van-form>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoPrint">{{ $t.meta.print }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Checkbox, CheckboxGroup } from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Checkbox)
  .use(CheckboxGroup);

export default {
  name: "commissionDetail",
  data() {
    return {
      OrderId: "",
      content: {
        Shipper: {
          CompanyName: "",
        },
        Consignee: {
          CompanyName: "",
        },
        Notify: {
          CompanyName: "",
        },
      },
      packing: "",
      weight: "",
      volume: "",
      shippmentData: [],
    };
  },
  created() {
    const { OrderId } = this.$route.query;
    if (OrderId) {
      this.OrderId = OrderId;
      this.getEntrustOrderInfo();
    }
  },
  methods: {
    getEntrustOrderInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          OrderId: this.OrderId,
        };
        this.$api.salesManagement
          .getEntrustOrderInfo(param)
          .then((res) => {
            this.content = res.data;
            if (this.content.Brand == 1) this.shippmentData.push(1);
            if (this.content.Liquid == 1) this.shippmentData.push(2);
            if (this.content.Powder == 1) this.shippmentData.push(3);
            if (this.content.Magnetic == 1) this.shippmentData.push(4);
            if (this.content.AgentExport == 1) this.shippmentData.push(5);
            if (this.content.ExportRebates == 1) this.shippmentData.push(6);
            if (this.content.Import == 1) this.shippmentData.push(7);
            this.packing =
              this.content.NumberPackages + " " + this.content.NumberPackagesUnitName;
            this.volume = this.content.Volume + " " + this.content.VolumeUnitName;
            this.weight = this.content.Weight + " " + this.content.WeightUnitName;
            this.$commonMethod.fieldRefresh(".commissionDetail");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    gotoPrint() {
      var param = {
        OrderId: this.OrderId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createEntrustOrderFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.commissionDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }

  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }

  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }

  .commissionDetail-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
